import { AsYouType, getCountryCallingCode } from "libphonenumber-js";
import type { CountryCode } from "libphonenumber-js";

/** Returns whether a phone value has no national number yet. */
export function isEmptyPublicBookingPhoneValue(
  value: string,
  dialCode: string,
): boolean {
  const trimmed = value.trim();
  return trimmed.length === 0 || trimmed === dialCode;
}

/** Hides the country prefix because the picker shows it separately. */
export function getPublicBookingPhoneDisplayValue(
  value: string,
  dialCode: string,
): string {
  const trimmedStart = value.trimStart();
  return trimmedStart.startsWith(dialCode)
    ? trimmedStart.slice(dialCode.length).trimStart()
    : value;
}

/** Formats user input into the international value persisted with a booking. */
export function formatPublicBookingPhoneValue(
  value: string,
  country: CountryCode,
): string {
  if (value.trim().length === 0) return "";

  const formatter = new AsYouType(country);
  return value.trimStart().startsWith("+")
    ? formatter.input(value.trimStart())
    : formatter.input(`+${getCountryCallingCode(country)} ${value}`);
}
